import { render, staticRenderFns } from "./addElementDialog.vue?vue&type=template&id=5b7cde30&"
import script from "./addElementDialog.vue?vue&type=script&lang=js&"
export * from "./addElementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports